import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import { getSurveySessionByUserId } from "../../services/firestoreService";
import { useAuth } from "../../context/AuthContext";
import type { SurveySession } from "../../typings";

export const useGetSurveySessionByUserIdQuery = (
  options?: Omit<UseQueryOptions<SurveySession | null>, "queryKey" | "queryFn">
) => {
  const { currentUser } = useAuth();
  return useQuery({
    queryKey: ["surveySession", currentUser?.uid],
    queryFn: async () => {
      if (!currentUser) return null;
      return await getSurveySessionByUserId(currentUser.uid);
    },
    enabled: !!currentUser,
    ...options,
  });
};
